import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormText from "./form/formText.component";
import FormTimeSlotInput from "./form/formTimeSlotInput.component";
import ContainerBox from "./common/containerBox.component";
import { SelectChangeEvent } from "@mui/material/Select";
import { stateProps } from "../types";
import { changeTimeSlots } from "../actions";

const TimeSlot: React.FC = () => {
  const dispatch = useDispatch();

  const timeslot = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.timeslot
  );

  const onInputTimeSlotsChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value, name },
    } = event;
    const allTimeSlots = typeof value === "string" ? value.split(",") : value;
    const updatedTimeSlots = timeslot.map((item) =>
      item.day === name ? { ...item, timeslots: allTimeSlots } : item
    );
    dispatch(changeTimeSlots(updatedTimeSlots));
  };

  const onInputDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, name } = event.target;
    const updatedTimeSlots = timeslot.map((item) =>
      item.day === name ? { ...item, status: checked } : item
    );
    dispatch(changeTimeSlots(updatedTimeSlots));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"10"}
          title={"What are your available times for consultations on oDoc?"}
        />
        <FormTimeSlotInput
          timeslot={timeslot}
          onInputDaysChange={onInputDaysChange}
          onInputTimeSlotsChange={onInputTimeSlotsChange}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default TimeSlot;
